var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMissionSportinline = function SvgMissionSportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sport"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "m32.057 33.739.003-.005-3.1-6.67c-4.793 3.656-7.283 5.885-11.446 9.232a1.626 1.626 0 0 0 1.63 1.62l10.63-.038a2.708 2.708 0 0 0 2.7-2.715 2.684 2.684 0 0 0-.417-1.424Z",
    fill: "#05152B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "m46.411 18.758-5.696 1.855-5.895-7.065-1.166 6.12 5.8 4.898a1.624 1.624 0 0 0 1.735.227L47.79 21.7a1.625 1.625 0 1 0-1.38-2.942Z",
    fill: "#05152B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.917 11.917a4.333 4.333 0 1 0 0-8.667 4.333 4.333 0 0 0 0 8.667Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.427 46.89c.01-.012.017-.026.026-.04L29.25 27.082l-1.936-11.94-8.979 18.392-5.725 11.77c-.006.015-.015.029-.02.045l-.01.017.003.002a1.616 1.616 0 0 0-.117.599c0 .897.728 1.625 1.625 1.625a1.62 1.62 0 0 0 1.328-.694l.001.001.007-.01Z",
    fill: "#1C385E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.167 26H6.5a1.084 1.084 0 0 0 0 2.167h8.667a1.084 1.084 0 0 0 0-2.167Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.417 21.666h-9.75a1.084 1.084 0 0 0 0 2.167h9.75a1.084 1.084 0 0 0 0-2.166Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.917 30.334H4.333a1.084 1.084 0 0 0 0 2.166h7.584a1.084 1.084 0 0 0 0-2.166Z",
    fill: "#F12B3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.7 18.054c.1-.035.195-.08.285-.131l.008-.003.017-.011 7.11-4.497 3.155 1.797-4.286 8.889-.02.041-.04.083.004.014c-.44.971-.536 2.101-.164 3.19a4.281 4.281 0 0 0 1.237 1.827l5.244-2.17c1.97-2.484 4.253-5.543 6.101-8.54l-.007-.02c.589-1.041.762-2.31.344-3.532-.447-1.306-1.462-2.243-2.671-2.668l-.008-.02-8.036-3.269c-.028-.014-.059-.023-.088-.036l-.169-.068-.01.001a2.15 2.15 0 0 0-1.4-.009c-.229.08-.43.2-.612.34l-.02.003-7.577 6.033-.01.009-.005.003a1.626 1.626 0 0 0 1.617 2.744Z",
    fill: "#1C385E"
  }))));
};
export default SvgMissionSportinline;